<sd-generic-link [url]="banner.link" (click)="onBannerClick(banner)">
  <img [ngSrc]="banner.url" [alt]="banner.altText" fill />
  <div class="banner-with-tab-content">
    <sd-generic-link [url]="banner.link">
      <div class="banner-with-tab-title text-b2-s-700 text-md-b2-l-700 text-xl-b2-l-700">{{ banner.title }}</div>
    </sd-generic-link>
    <div class="text-c2-m-300 text-md-b4-m-300 text-xl-b1-s-300 banner-with-tab-description">
      {{ banner.description }}
    </div>
  </div>
</sd-generic-link>
